<sb-dashboard-widget
  [isLoading]="isLoading()"
  [isEmpty]="employeesWithContracts().length === 0"
  [title]="'Ending contracts' | translate"
  [emptySettings]="{
    description: 'You\'ll see ending contracts for your team here.' | translate,
    icon: 'file-certificate-cute-re',
  }"
>
  <sb-dashboard-widget-select
    [options]="periodOptions"
    [model]="widgetPeriod()"
    (modelChange)="onPeriodChange($event)"
    [label]="'Next' | translate"
  />
  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th class="row-30">{{ 'Name' | translate }}</th>
        <th class="row-30">{{ 'Contract type' | translate }}</th>
        <th class="row-20">{{ 'Last workday' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (employee of employeesWithContracts(); track employee.id) {
        <tr class="cursor-pointer" [routerLink]="['/employees', employee.id, 'contracts']" role="link">
          <td data-hj-suppress>{{ employee.name }}</td>
          <td>{{ employee.contract?.contract_type?.name }}</td>
          <td>{{ employee.enddate | localeDate: 'medium' }}</td>
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
